import { application as rawApplication } from './application';
import { AuthServiceProvider, auth as rawAuth } from './auth';
import { createSafeExecutionProxy } from '../safe-execution';
import { ApplicationType } from './application';

export const application =
	createSafeExecutionProxy<ApplicationType>(rawApplication);
export const auth = (authProvider: AuthServiceProvider) =>
	createSafeExecutionProxy(rawAuth(authProvider));
